import clsx from 'clsx'
import { getAttribute } from 'helpers/dom'
import { AnimatePresence, motion } from 'motion/react'
import { sortOptions, localSort, applySort, setLocalSort } from 'snippets/plp-native/@store'

function PlpNativeSortOptions({ isActive, setIsActive }) {
  const handleChange = (e) => {
    const name = getAttribute('data-value', e.target)
    const current = sortOptions.value.find((item) => item.label === name)

    setLocalSort(current)
    applySort(current)
    setIsActive(false)
  }

  return (
    <AnimatePresence>
      {isActive && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.3, ease: 'easeInOut' } }}
          transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }}
          className="absolute left-0 right-0 top-[calc(100%_+_1px)] z-30 space-y-4 border-b border-neutral-900 bg-white p-5 md:left-[unset] md:min-w-[360px] md:border-x"
        >
          {sortOptions.value.map((option) => (
            <button
              type="button"
              key={option.label}
              aria-label={`Sort by ${option.label}`}
              onClick={handleChange}
              data-value={option.label}
              className={clsx(
                'text-xs block transition-all duration-300 hover:text-neutral-900',
                option.field === localSort.value.field ? 'font-extrabold text-neutral-900' : 'font-normal text-neutral-700'
              )}
            >
              {option.label}
            </button>
          ))}
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default PlpNativeSortOptions
